module.exports = __webpack_public_path__ + "img/game.62242b49.svg";